import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const permissionsApi = api
  .enhanceEndpoints({ addTagTypes: ["permissions"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      permissions: builder.query({
        query: ({ branchId }) => ({
          url: `/branchs/${branchId}/permissions`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data),
        providesTags: ["permissions"],
      }),
    }),
  });

export const { usePermissionsQuery } = permissionsApi;
